export default ({ service }) => {

    const set_service = () => {

        let arr = service.value.split(',')

        if (service.serviceId == 1) return `Channels  (${arr.length})`

        else if (service.serviceId == 2) return `EPG  (${arr.length})`

        else if (service.serviceId == 3) return `Archive (${arr.length})`

        else if (service.serviceId == 4) return `Devices count (${service.value})`

        else if (service.serviceId == 5) return `VOD (${arr.length})`

    }

    return (

        <div className={"tariff_service " + (!service.value ? "" : "checked")}>
            {set_service()}
        </div>

    )
}